export default __webpack_public_path__ + "static/media/image-artist-4.1fa446e1.jpg";